<script lang="ts" setup>
  import { computed } from 'vue';
  import { useShared } from '@othercommerce/foundation';

  interface HasCatalogPrice {
    regularGross: string | null;
    catalogNet: string | null;
    catalogTax: string | null;
    catalogGross: string | null;
    catalogDiscount: string | null;
  }

  interface Props {
    item: HasCatalogPrice;
  }

  const props = defineProps<Props>();
  const shared = useShared();

  const price = computed(() => {
    if (shared.value.includeVat) {
      return props.item.catalogGross;
    } else {
      return props.item.catalogNet;
    }
  });

  const discount = computed(() => {
    return Number(props.item.catalogDiscount) * 100;
  });

  const visible = computed(() => {
    return props.item.catalogGross !== props.item.regularGross && discount.value > 0;
  });
</script>
<template>
  <div v-if="visible" class="product-catalog">
    <span>
      {{ $t('SHOP.COMMON.LABEL.CATALOG_PRICE') }}
      <SfMoney :value="price" class="product-catalog-price" />
    </span>
    <span class="product-catalog-discount">
      <SfFormattedPercentage :options="{ minimumFractionDigits: 2, maximumFractionDigits: 2 }" :value="discount" />
    </span>
  </div>
</template>
<style lang="scss" scoped>
  .product-catalog {
    display: flex;
    flex-wrap: wrap-reverse;
    justify-content: flex-start;
    align-items: center;
    column-gap: 0.5rem;
    font-size: 0.75rem;
    margin: 0.25rem 0;
    color: var(--color-default);

    .product-catalog-price {
      font-weight: var(--font-weight-bold);
    }

    .product-catalog-discount {
      display: inline-block;
      padding: 0.125rem 0.375rem;
      font-weight: var(--font-weight-bold);
      background: var(--primary-color);
      color: var(--primary-foreground);
      border-radius: var(--border-radius);
    }
  }
</style>
